import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-y-3"
}

import { ref, watch } from "vue"
import { Filter, FiltersGroup } from "@/shared/models/filter"
import FilterRule from "@/components/filters/FilterRule.vue"
import FilterList from "@/components/filters/FilterList.vue"
import { useWorkflowStore } from "@/stores/workflow"


export default /*@__PURE__*/_defineComponent({
  __name: 'PageVisitedFilterTriggerSidebar',
  setup(__props) {

const workflowStore = useWorkflowStore()

const selectedFilterIndex = ref(0)
const selectedFilterGroup = ref(0)
const isEditFilter = ref(false)

const selectedFilter = ref<Filter>({
    field: "properties.url",
    type: "string",
    rule: "",
    value: "",
    displayName: "Url",
})

function isFilterEmpty(filter: Filter): boolean {
    return (
        (filter.value === "" ||
            (Array.isArray(filter.value) && filter.value.length === 0) ||
            (Array.isArray(filter.value) && filter.value.every((val) => val === ""))) &&
        filter.rule !== "isEmpty" &&
        filter.rule !== "isNotEmpty" &&
        filter.rule !== "isAny"
    )
}

function openFiltersList() {
    workflowStore.currentStep = "filterList"
    isEditFilter.value = false
}

function isCurrentFilterStep(step: string): boolean {
    return workflowStore.currentStep === step
}

async function applyFilter(filter: Filter) {
    selectedFilter.value = filter
    isEditFilter.value ? editFilterGroup(filter, selectedFilterIndex.value) : addFilterToGroup(filter)
    openFiltersList()

    if (isFilterEmpty(filter)) {
        // Filter out non-empty filters
        workflowStore.pageVisitedFiltersGroups?.forEach((filterGroup: FiltersGroup) => {
            filterGroup.filters = filterGroup.filters.filter((f: Filter) => !isFilterEmpty(f))
        })

        // Filter out filter groups with no filters
        workflowStore.pageVisitedFiltersGroups = workflowStore.pageVisitedFiltersGroups?.filter(
            (filterGroup: FiltersGroup) => filterGroup.filters.length > 0
        )

        if (workflowStore.pageVisitedFiltersGroups?.length === 0) {
            workflowStore.pageVisitedFiltersGroups = [{ filters: [] }] // Ensure at least one empty group
            openFiltersList()
        }
    }
    resetSelectedFilter()
}

function editFilterGroup(filter: Filter, filterIndex: number) {
    workflowStore.pageVisitedFiltersGroups[selectedFilterGroup.value].filters[filterIndex] = filter
}

function addFilterToGroup(filter: Filter) {
    if (!workflowStore.pageVisitedFiltersGroups[selectedFilterGroup.value]) {
        workflowStore.pageVisitedFiltersGroups?.push({ filters: [filter] })
    } else {
        workflowStore.pageVisitedFiltersGroups[selectedFilterGroup.value].filters.push(filter)
    }
}

function addNewFilterToGroup(groupIndex: number) {
    isEditFilter.value = false
    selectedFilterGroup.value = groupIndex
    resetSelectedFilter()
    workflowStore.currentStep = "filterRule"
}

function editFilter(filter: Filter, groupIndex: number, filterIndex: number) {
    selectedFilter.value = {
        field: filter.field,
        type: filter.type,
        rule: filter.rule,
        value: filter.value,
        displayName: filter.displayName,
    }
    selectedFilterIndex.value = filterIndex
    selectedFilterGroup.value = groupIndex
    isEditFilter.value = true
    workflowStore.currentStep = "filterRule"
}

function clearFilters() {
    workflowStore.pageVisitedFiltersGroups = [{ filters: [] }]
    selectedFilterGroup.value = 0
    resetSelectedFilter()
    workflowStore.currentStep = "filterRule"
    isEditFilter.value = false
}

function resetSelectedFilter() {
    selectedFilter.value = {
        field: "properties.url",
        type: "string",
        rule: "",
        value: "",
        displayName: "Url",
    }
}

function removeGroup(groupIndex: number) {
    workflowStore.pageVisitedFiltersGroups?.splice(groupIndex, 1)
    if (workflowStore.pageVisitedFiltersGroups?.length === 0) {
        workflowStore.pageVisitedFiltersGroups = [{ filters: [] }]
    }
    selectedFilterGroup.value = Math.min(selectedFilterGroup.value, workflowStore.pageVisitedFiltersGroups.length - 1)
}

function removeFilter(groupIndex: number, filterIndex: number) {
    workflowStore.pageVisitedFiltersGroups[groupIndex].filters.splice(filterIndex, 1)
    if (workflowStore.pageVisitedFiltersGroups[groupIndex].filters.length === 0) {
        workflowStore.pageVisitedFiltersGroups?.splice(groupIndex, 1)
    }
    if (workflowStore.pageVisitedFiltersGroups?.length === 0) {
        workflowStore.pageVisitedFiltersGroups = [{ filters: [] }]
    }
    selectedFilterGroup.value = Math.min(selectedFilterGroup.value, workflowStore.pageVisitedFiltersGroups.length - 1)
}

function addNewGroup() {
    workflowStore.pageVisitedFiltersGroups?.push({ filters: [] })
    selectedFilterGroup.value = workflowStore.pageVisitedFiltersGroups.length - 1
    resetSelectedFilter()
    isEditFilter.value = false
    workflowStore.currentStep = "filterRule"
}

watch(
    () => workflowStore.pageVisitedFiltersGroups,
    () => (workflowStore.areButtonDisabled = workflowStore.pageVisitedFiltersGroups[0]?.filters.length === 0),
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isCurrentFilterStep('filterRule'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-gray-900 text-lg font-medium" }, "URL", -1)),
          _createVNode(FilterRule, {
            filter: selectedFilter.value,
            isUpdated: isEditFilter.value,
            showHeader: false,
            isWorkflowTrigger: true,
            onApplyFilter: applyFilter
          }, null, 8, ["filter", "isUpdated"])
        ]))
      : _createCommentVNode("", true),
    (isCurrentFilterStep('filterList'))
      ? (_openBlock(), _createBlock(FilterList, {
          key: 1,
          savedFiltersGroups: _unref(workflowStore).pageVisitedFiltersGroups,
          isWorkflowTrigger: true,
          onAddNewFilter: addNewFilterToGroup,
          onEditFilter: editFilter,
          onClearFilters: clearFilters,
          onRemoveGroup: removeGroup,
          onRemoveFilter: removeFilter,
          onAddNewGroup: addNewGroup
        }, null, 8, ["savedFiltersGroups"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})